import { render, staticRenderFns } from "./LayPeriodicalJournal.vue?vue&type=template&id=a6cce372&scoped=true&"
import script from "./LayPeriodicalJournal.vue?vue&type=script&lang=js&"
export * from "./LayPeriodicalJournal.vue?vue&type=script&lang=js&"
import style0 from "./LayPeriodicalJournal.vue?vue&type=style&index=0&id=a6cce372&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cce372",
  null
  
)

export default component.exports